/**
 * Build-time environment values (inlined by dotenv-webpack at compile time).
 * Each entry MUST use a literal `process.env.VAR` — dynamic `process.env[name]` is not replaced.
 */
export const BUILD_ENV = {
    NODE_ENV: typeof process.env.NODE_ENV === 'string' ? process.env.NODE_ENV : 'development',
    /** User-management / IAM gateway (login, account, users, roles, permissions). */
    BACKEND_URL: typeof process.env.BACKEND_URL === 'string' ? process.env.BACKEND_URL.trim() : '',
    /** Call-center CRM microservice (cases, reports, agent panel, chat websocket, …). */
    CRM_BACKEND_URL: typeof process.env.CRM_BACKEND_URL === 'string' ? process.env.CRM_BACKEND_URL.trim() : '',
    /**
     * `1` — browser calls same-origin `/api`, `/user-management`, `/websocket`; webpack proxies by prefix.
     * Recommended for local dev to avoid CORS.
     */
    USE_DEV_PROXY: typeof process.env.USE_DEV_PROXY === 'string' ? process.env.USE_DEV_PROXY.trim() : '',
    SIP_WS_URL: typeof process.env.SIP_WS_URL === 'string' ? process.env.SIP_WS_URL.trim() : '',
    SIP_DOMAIN_HOST: typeof process.env.SIP_DOMAIN_HOST === 'string' ? process.env.SIP_DOMAIN_HOST.trim() : '',
    SIP_EXTENSION: typeof process.env.SIP_EXTENSION === 'string' ? process.env.SIP_EXTENSION.trim() : '',
    SIP_AUTH_ID: typeof process.env.SIP_AUTH_ID === 'string' ? process.env.SIP_AUTH_ID.trim() : '',
    SIP_PASSWORD: typeof process.env.SIP_PASSWORD === 'string' ? process.env.SIP_PASSWORD.trim() : '',
    SIP_SUPERVISE_SNOOP_CODE: typeof process.env.SIP_SUPERVISE_SNOOP_CODE === 'string'
        ? process.env.SIP_SUPERVISE_SNOOP_CODE.trim()
        : '',
    SIP_SUPERVISE_WHISPER_CODE: typeof process.env.SIP_SUPERVISE_WHISPER_CODE === 'string'
        ? process.env.SIP_SUPERVISE_WHISPER_CODE.trim()
        : '',
    SIP_SUPERVISE_BARGE_CODE: typeof process.env.SIP_SUPERVISE_BARGE_CODE === 'string'
        ? process.env.SIP_SUPERVISE_BARGE_CODE.trim()
        : '',
    SIP_SUPERVISE_CONFERENCE_CODE: typeof process.env.SIP_SUPERVISE_CONFERENCE_CODE === 'string'
        ? process.env.SIP_SUPERVISE_CONFERENCE_CODE.trim()
        : '',
    SIP_SUPERVISE_FORCE_HANGUP_CODE: typeof process.env.SIP_SUPERVISE_FORCE_HANGUP_CODE === 'string'
        ? process.env.SIP_SUPERVISE_FORCE_HANGUP_CODE.trim()
        : '',
    SIP_SUPERVISE_CONFERENCE_ROOM: typeof process.env.SIP_SUPERVISE_CONFERENCE_ROOM === 'string'
        ? process.env.SIP_SUPERVISE_CONFERENCE_ROOM.trim()
        : '',
    ASTERISK_AMI_HOST: typeof process.env.ASTERISK_AMI_HOST === 'string' ? process.env.ASTERISK_AMI_HOST.trim() : '',
    ASTERISK_AMI_PORT: typeof process.env.ASTERISK_AMI_PORT === 'string' ? process.env.ASTERISK_AMI_PORT.trim() : '',
    ASTERISK_AMI_SCHEME: typeof process.env.ASTERISK_AMI_SCHEME === 'string' ? process.env.ASTERISK_AMI_SCHEME.trim() : '',
    ASTERISK_AMI_PROXY_TARGET: typeof process.env.ASTERISK_AMI_PROXY_TARGET === 'string'
        ? process.env.ASTERISK_AMI_PROXY_TARGET.trim()
        : '',
    ASTERISK_AMI_HTTP_URL: typeof process.env.ASTERISK_AMI_HTTP_URL === 'string'
        ? process.env.ASTERISK_AMI_HTTP_URL.trim()
        : '',
    ASTERISK_AMI_USERNAME: typeof process.env.ASTERISK_AMI_USERNAME === 'string'
        ? process.env.ASTERISK_AMI_USERNAME.trim()
        : '',
    ASTERISK_AMI_SECRET: typeof process.env.ASTERISK_AMI_SECRET === 'string' ? process.env.ASTERISK_AMI_SECRET.trim() : '',
    ASTERISK_AMI_TIMEOUT_MS: typeof process.env.ASTERISK_AMI_TIMEOUT_MS === 'string'
        ? process.env.ASTERISK_AMI_TIMEOUT_MS.trim()
        : '',
    /** Set by `npm run preview` so production bundles keep same-origin proxy paths. */
    WEBPACK_SERVE: typeof process.env.WEBPACK_SERVE === 'string' ? process.env.WEBPACK_SERVE.trim() : '',
    /**
     * SockJS/STOMP master switch (chat + session + break topics). `1`/`true` = on; unset = off.
     * Avoids cross-origin `/websocket/app/info` unless explicitly enabled.
     */
    ENABLE_STOMP_WS: typeof process.env.ENABLE_STOMP_WS === 'string' ? process.env.ENABLE_STOMP_WS.trim() : '',
    /** CRM team chat (requires `ENABLE_STOMP_WS=1`). `1`/`true` = on; unset = off. */
    ENABLE_CRM_CHAT: typeof process.env.ENABLE_CRM_CHAT === 'string' ? process.env.ENABLE_CRM_CHAT.trim() : '',
    CHAT_SOCKJS_PATH: typeof process.env.CHAT_SOCKJS_PATH === 'string' ? process.env.CHAT_SOCKJS_PATH.trim() : '',
    /**
     * `1` / `true` — SockJS connects to CRM host directly (cross-origin).
     * Default: same-origin `/websocket/...` via webpack/nginx proxy (required for auth on `/info`).
     */
    CHAT_CROSS_ORIGIN: typeof process.env.CHAT_CROSS_ORIGIN === 'string' ? process.env.CHAT_CROSS_ORIGIN.trim() : '',
};
export const IS_PRODUCTION_BUILD = BUILD_ENV.NODE_ENV === 'production';
/** Production build served as static files (no webpack dev-server proxies). */
export const IS_STATIC_PRODUCTION_DEPLOY = IS_PRODUCTION_BUILD &&
    BUILD_ENV.WEBPACK_SERVE !== '1' &&
    BUILD_ENV.WEBPACK_SERVE.toLowerCase() !== 'true';
